import { createApiClient } from "./apiClient";

export function downloadFile(directoryName: string, fileName: string) {
    const axiosClient = createApiClient();
    axiosClient
        .post("/api/Download/File", { directoryName, fileName }, {
            responseType: "blob",
        })
        .then((response) => {
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }, 200);
        });
}
